module.exports = __webpack_public_path__ + "img/同意转借.cbb64f36.png";